module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1005-46ba1bba807934aeb18aa95c2bcd22b2.png";